import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'rt-emoji',
  templateUrl: './emoji.component.html',
  styleUrls: ['./emoji.component.less'],
  host: {
    '[style.font-size.px]': 'size()',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class EmojiComponent {
  public readonly emoji = input<string>(undefined!);
  public readonly size = input<14 | 20 | 24>(undefined!);
}
